import req from './req'

// 表单管理 - 表单模板列表
export function getFormsTemplateList (params) {
  return req.get('/forms/template/list', params)
}

// 表单管理-状态变更接口
export function changeFormsTemplateStatus (params) {
  return req.post('/forms/template/changeStatus', params)
}

// 表单管理-复制接口
export function copyFormsTemplate (params) {
  return req.post('/forms/template/copy', params)
}

// 表单活动-新建表单活动接口
export function createFormsActivity (params) {
  return req.post('/forms/activity/create', params)
}

// 表单活动-编辑表单活动接口
export function updateFormsActivity (params) {
  return req.post('/forms/activity/update', params)
}

// 表单活动 - 表单活动详情接口
export function getFormsActivityInfo (params) {
  return req.get('/forms/activity/info', params)
}

// 表单活动-活动删除接口
export function removeFormsActivity (params) {
  return req.post('/forms/activity/remove', params)
}

// 表单活动-强制结束活动接口
export function endFormsActivity (params) {
  return req.post('/forms/activity/end', params)
}

// 表单活动 - 活动列表
export function getFormsActivityList (params) {
  return req.get('/forms/activity/list', params)
}

// 表单活动-复制接口
export function copyFormsActivity (params) {
  return req.post('/forms/activity/copy', params)
}

// 表单活动-分享设置接口
export function shareSettingFormsActivity (params) {
  return req.post('/forms/activity/shareSetting', params)
}

// 表单活动-生成分享二维码接口
export function getFormsActivityQrcode (params) {
  return req.get('/forms/activity/qrcode', params)
}

// 表单管理 - 渠道活码
export function fetchDynamicCode (params) {
  return req.get('/traffic/dynamic-code/list', params)
}

// 表单活动统计-实时数据数据
export function fetchRealTimeCount (params) {
  return req.get('/forms/statistics/real-time-count', params)
}

// 表单活动统计-每日统计数据
export function fetchEveryTimeCount (params) {
  return req.get('/forms/statistics/every-data-count', params)
}

// 表单活动-活动提交记录列表接口
export function fetchActivityRecordList (params) {
  return req.get('/forms/activityRecord/list', params)
}

// 表单活动-活动记录编辑接口
export function fetchActivityRecordEdit (params) {
  return req.get('/forms/activityRecord/edit', params)
}

// 表单活动-活动记录详情接口
export function fetchActivityRecordInfo (params) {
  return req.get('/forms/activityRecord/info', params)
}

// 添加投放渠道接口
export function createChannel (params) {
  return req.post('/forms/channel/create', params)
}

// 渠道列表接口
export function listChannel (params) {
  return req.get('/forms/channel/list', params)
}
